import Button from '@/components/basicComponents/button';
import NoResults from '@/components/table/noResults';
import { TableRowCell, TableRowWrapper, TextCell } from '@/components/table/styles';
import { TableColumns } from '@/components/table/types';
import guid from '@/shared/utils/guid';
import styled from 'styled-components';
import { InvestorEntitiesRowStatus } from '../../../investorEntitiesRowStatus';
import { IEntityImportComparison, ImportInvestorEntitiesUpdateMethodOptionEnum, TypeWindow } from '../../../types';

interface TableBodyProps {
  tableColumns: TableColumns[];
  tableData: IEntityImportComparison[];
  updateMethod: ImportInvestorEntitiesUpdateMethodOptionEnum;
  openEntityImportDetailPage: (type: TypeWindow, row: IEntityImportComparison) => void;
}

const TableBody = ({ tableColumns, tableData, updateMethod, openEntityImportDetailPage }: TableBodyProps) => {
  if (!tableData.length) {
    return <NoResults />;
  }

  return (
    <>
      {tableData.map((row) => (
        <CustomTableRowWrapper key={guid()}>
          <TableRowCell width={tableColumns[0].width}>
            <TextCell>
              {updateMethod === ImportInvestorEntitiesUpdateMethodOptionEnum.UpdateUsingEntityStaticID ? row?.id : row?.entityCRMId}
            </TextCell>
          </TableRowCell>
          <TableRowCell width={tableColumns[1].width}>
            <TextCell>{row.entityName}</TextCell>
          </TableRowCell>
          <TableRowCell width={tableColumns[2].width}>
            <TextCell>
              <TextCell>{row.householdName}</TextCell>
            </TextCell>
          </TableRowCell>
          {/* <TableRowCell width={tableColumns[3].width}>
            <TextCell >{row.fieldsModifiedCount}</TextCell>
          </TableRowCell> */}
          <TableRowCell width={tableColumns[3].width}>
            <TextCell>
              <InvestorEntitiesRowStatus status={row.status} />
            </TextCell>
          </TableRowCell>
          <TableRowCell width={tableColumns[4].width}>
            {row.status !== 'toDelete' && (
              <ButtonWrap id="infoWrap">
                <Button size="sm" onClick={() => openEntityImportDetailPage('entityImportDetail', row)}>
                  View
                </Button>
              </ButtonWrap>
            )}
          </TableRowCell>
        </CustomTableRowWrapper>
      ))}
    </>
  );
};

export default TableBody;

const CustomTableRowWrapper = styled(TableRowWrapper)`
  justify-content: space-between;
`;

const ButtonWrap = styled.div`
  opacity: 0;
`;
